module.exports = __webpack_public_path__ + "static/img/bg-ar.77b1d744.png";